module.exports = __webpack_public_path__ + "igdc2025-7b24a3de.jpg";